import { Ref, ref, onMounted, onBeforeUnmount } from "vue";

export function useWindowResize(
  wrapperRef: Ref<HTMLDivElement | undefined>,
  menuWrapperMoveRef: Ref<HTMLDivElement | undefined>
): {
  wrapperSize: Ref<number>;
  moveWrapperSize: Ref<number>;
  shouldArrowVisible: Ref<boolean>;
} {
  const wrapperSize = ref<number>(0);
  const moveWrapperSize = ref<number>(0);
  // 是否展示箭头
  const shouldArrowVisible = ref<boolean>(false);

  function refreshSize() {
    if (wrapperRef.value) {
      wrapperSize.value = wrapperRef.value.offsetWidth;
    }
    if (menuWrapperMoveRef.value) {
      moveWrapperSize.value = menuWrapperMoveRef.value.offsetWidth;
    }
    shouldArrowVisible.value = moveWrapperSize.value > wrapperSize.value;
  }

  onMounted(() => {
    refreshSize();
    window.addEventListener("resize", refreshSize);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", refreshSize);
  });

  return { wrapperSize, moveWrapperSize, shouldArrowVisible };
}
